export default __webpack_public_path__ + "static/media/dashboardV2.0727a853.jpg";